import PropTypes from "prop-types";

import { cn } from "@helpers/general";

import LuxeUncheck from "@svgs/luxe_uncheck.svg";
import LuxeSelected from "@svgs/luxe_selected.svg";
import LuxeUnselected from "@svgs/luxe_unselected.svg";

function GuestCell({ perk, isLuxe, sideCartInfo, formatCurrency, maxTieredDiscountNonLuxe }) {
  if (typeof perk.non_member === "boolean") {
    return <LuxeUncheck stroke="#000000" width="10px" height="10px" />;
  }

  if (perk.non_member === "Guest") {
    return (
      <>
        {isLuxe ? (
          <LuxeUnselected className="mr-[5px]" width="17px" height="17px" />
        ) : (
          <LuxeSelected className="mr-[5px]" width="17px" height="17px" />
        )}
        <span className="typo-micro font-bold">{perk.non_member}</span>
      </>
    );
  }

  if (perk.type === "footer") {
    return (
      <div
        className={cn(
          "typo-micro font-bold rounded bg-white py-[3px] px-[15px]",
          isLuxe ? "text-black" : "text-secondary"
        )}
      >
        {formatCurrency(sideCartInfo.finalAmount)}
      </div>
    );
  }
  if (perk.non_member.includes("{0}") && maxTieredDiscountNonLuxe === 0) {
    return <LuxeUncheck stroke="#000000" width="10px" height="10px" />;
  }

  return perk.non_member.replace("{0}", maxTieredDiscountNonLuxe);
}

GuestCell.propTypes = {
  perk: PropTypes.shape({
    non_member: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
    type: PropTypes.string,
  }).isRequired,
  isLuxe: PropTypes.bool.isRequired,
  sideCartInfo: PropTypes.shape({
    finalAmount: PropTypes.number.isRequired,
  }).isRequired,
  formatCurrency: PropTypes.func.isRequired,
  maxTieredDiscountNonLuxe: PropTypes.number.isRequired,
};

export default GuestCell;
